import React from 'react';

import { Paragraph } from '@periodica/ui-kit';

import * as styles from './icons.module.css';

function Vector() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="none">
      <path
        fill="currentColor"
        d="M0 32A32 32 0 0 1 16 4.287l.24.416A31.52 31.52 0 0 0 .48 32l.004.519A31.52 31.52 0 0 0 16.24 59.297l-.24.416a32 32 0 0 1-11.446-11.26L4.287 48A32 32 0 0 1 .004 32.526zm63.52 0A31.52 31.52 0 0 0 47.76 4.703l.24-.416A32 32 0 0 1 64 32l-.005.526A32 32 0 0 1 59.713 48l-.267.453A32 32 0 0 1 48 59.713l-.24-.416a31.52 31.52 0 0 0 15.756-26.778z"
      />
    </svg>
  );
}

export function Dzen() {
  return (
    <div className={styles.icon}>
      <Vector />
      <Paragraph className={styles.iconText}>ДЗЕН</Paragraph>
    </div>
  );
}

export function Tg() {
  return (
    <div className={styles.icon}>
      <Vector />
      <Paragraph className={styles.iconText}>ТГ</Paragraph>
    </div>
  );
}

export function Vk() {
  return (
    <div className={styles.icon}>
      <Vector />
      <Paragraph className={styles.iconText}>ВК</Paragraph>
    </div>
  );
}
